import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios';
import { useMediaQuery, Alert as MuiAlert, Snackbar } from '@mui/material'
import "primereact/resources/themes/lara-light-indigo/theme.css"
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css'
import { LoadingContext, LoadingBar } from '../../M_Components'
import { DefaultURl } from '../../M_Components';

export function M_Router({ Routing, url, primaryColor, secondaryColor, tertiaryColor, endpoints }) {
    const [isLoad, setIsLoad] = useState(false)
    const isLoadingRef = useRef(false)

    const setIsLoadWithRef = (value) => {
        isLoadingRef.current = value
        if (value) {
            sessionStorage.setItem('isPageLoading', '1')
        } else {
            sessionStorage.removeItem('isPageLoading')
        }
        setIsLoad(value)
    }
    const [isOpenToast, setIsOpenToast] = useState(false)
    const [alertMessage, setAlertMessage] = useState("")
    const [colorSnack, setColorSnack] = useState("")
    const [alertFunction, setAlertFunction] = useState("")
    const [useComma, setUseComma] = useState(true)
    const [passValues, setPassValues] = useState()
    const [passValue, setPassValue] = useState(new Map())

    // const DEFAULTURL = url ? url : DefaultURl

    const matches = useMediaQuery('(min-width:1200px)')

    endpoints = endpoints ? endpoints : []



    axios.interceptors.request.use(
        config => {
            const newToken = localStorage.getItem("tokenMaeil")
            if (!config.url.includes('identity/forgetpassword')) {
                if (newToken) {

                    config.headers['Authorization'] = 'Bearer' + ' ' + newToken

                    let shouldSkip = false
                    endpoints.forEach(end => {
                        if (shouldSkip) return
                        if (config.url.includes(`/${end}?`)) {
                            let tempURL = config.url.replace('?', '/query?')
                            config.url = tempURL
                            shouldSkip = true
                        }
                    })
                } else {
                    if (!config.url.includes(`/${'login'}`))
                        window.location.href = '/login'
                }
            }
            return config
        }
    )
    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            if (error.response.status === 401) {
                window.location.href = '/login'
                return Promise.reject(error)
            }
            return Promise.reject(error)
        }
    )

    useEffect(() => {
        const timer = setTimeout(() => {
            if (isLoad === true) {
                setIsLoad(false)
                toastMessages('error', 'Load Timeout', 'Error: ')
            }
        }, 100000);
        return () => {
            clearTimeout(timer)
        }
    }, [isLoad])

    const toastMessages = (type, alert, string) => {
        setIsOpenToast(true)
        setColorSnack(type)
        setAlertMessage(alert)
        setAlertFunction(string)
    }

    const handleClose = (reason) => {
        if (reason === 'clickaway') {
            return
        }
        setIsOpenToast(false)
    }

    const Alert = React.forwardRef(function Alert(props, ref) {
        return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
    })

    return (
        <LoadingContext.Provider value={{
            isLoad: isLoad,
            setIsLoad: setIsLoadWithRef,
            isLoadingRef: isLoadingRef,
            isOpenToast: isOpenToast,
            setIsOpenToast: setIsOpenToast,
            alertMessage: alertMessage,
            setAlertMessage: setAlertMessage,
            colorSnack: colorSnack,
            setColorSnack: setColorSnack,
            alertFunction: alertFunction,
            setAlertFunction: setAlertFunction,
            toastMessages: toastMessages,
            handleClose: handleClose,
            useComma: useComma,
            setUseComma: setUseComma,
            passValues: passValues,
            setPassValues: setPassValues,
            // DEFAULTURL: DEFAULTURL,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            tertiaryColor: tertiaryColor,
            passValue: passValue,
            setPassValue: setPassValue
        }}>
            <div style={isLoad ?
                { position: 'fixed', height: '100vh', width: '100%', zIndex: '5000000', top: '0', backgroundColor: 'var(--color-grey-light)', opacity: '0.8', overflow: 'hidden' } :
                { position: 'absolute', height: '100%', width: '100%', display: 'none' }}>
                <div style={matches ? { height: '50px' } : { height: '100px' }}></div>
                <LoadingBar />
            </div>
            {Routing}
            <Snackbar disableWindowBlurListener={true} open={isOpenToast} autoHideDuration={5000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={colorSnack} sx={{ width: '100%' }}>
                    {alertFunction}<b>{alertMessage}</b>
                </Alert>
            </Snackbar>
        </LoadingContext.Provider>
    )
}


